import {renderCartSocialProof} from "../../modules/social-proof";
import { initTracking } from './tracking';
import $ from 'jquery';
import Keyboard from 'styleguide/modules/keyboard';

function applyCouponCode(couponCode, isAutoApply) {

    $('.js-promo-error-msg').removeClass('is-error');
    $('#promocode-error').text('').hide();
    if(couponCode === ""){
        couponCode = $('#promo').val();
    }
    if(couponCode) {
        var successCallBack = function (obj) {
            if (obj.success) { // coupon applied ok but applied with restriction or with 0 amount
                if (!obj.msg10) { // coupon not applied
                    $('#coupon_applied_invalid').html(obj.msg14 || obj.msg9).slideDown();
                    $('#summary_coupon').hide();
                    $('#summary_coupon_code').text('').hide();
                    $('.coupon_applied').hide();
                    $('#promo').val('');
                    if(obj.msg15){
                        $('#totalAfterPayPayment').html(obj.msg15);
                    }
                    return;
                } else if (obj.msg4) { // invalid promo code
                    $('#coupon_applied_invalid').html('');
                    $('#summary_coupon').hide();
                    $('#total').text(obj.msg3);

                } else {
                    $('#promo').data('applied-coupon-code', couponCode);
                    if (obj.msg14) { // for restrictions
                        $('#coupon_applied_invalid').html(obj.msg14 || obj.msg9).slideDown();
                    } else {
                        $('#coupon_applied_invalid').html('').hide();
                    }
                    $('#discountAmount').html(obj.msg2);
                    $('#summary_coupon').show();
                    $('#summary_coupon_code').text('Promo Code: ' + couponCode).show();
                    $('#summary_coupon_amount').text(obj.msg2).show();
                    $('#total').text(obj.msg3);
                    $('.coupon_applied').show();
                    $('#promo').val('');
                    if(obj.msg15){
                        $('#totalAfterPayPayment').html(obj.msg15);
                    }
                }
                if(typeof isAutoApply == "undefined" || !isAutoApply){
                    updateMiniBag(false);
                }
            } else { // Invalid coupon code.
                $('.js-promo-error-msg').addClass('is-error');
                $('#promocode-error').text(obj.msg4 ? obj.msg4 : 'Invalid code').show();
                if(obj.msg15){
                    $('#totalAfterPayPayment').html(obj.msg15);
                }
            }
        }
        applyPromo(couponCode, successCallBack);
    }
}

function removeCoupon(){
    var successCallBack = function (obj){
        $('#summary_coupon').hide();
        $('#coupon_applied_invalid').html('').hide();
        $('#summary_coupon_code').text('');
        $('#summary_coupon_amount').text('');
        $('#total').text(obj.msg3);
        $('.coupon_applied').hide();
        $('#promo').data('applied-coupon-code', "");
        if(obj.msg15){
            $('#totalAfterPayPayment').html(obj.msg15);
        }
        updateMiniBag(false);
    }
    applyPromo("", successCallBack);
}

function reApplyCouponForCartRefresh(){
    if(window.shoppingBagCoupenCodeABtest){
        let appliedCouponCode = $('#promo').data('applied-coupon-code');
        if(appliedCouponCode)
            applyCouponCode(appliedCouponCode, true);
    }
}

function initSizeSelector() {
    // Load HTML content and then show popup
    $('.js-sb-add-to-bag-size').on('click', function (event) {
        var clickedButton = $(this); // Store reference to clicked button
        var code = clickedButton.data('code');
        // Load the HTML content first
        $.ajax({
            url: '/r/ajax/GetProductSizeMenu.jsp?code=' + code,
            type: 'GET',
            success: function (htmlContent) {
                const target = document.querySelector('#sb-rec-size-menu-container');
                // Insert the HTML into container
                target.innerHTML = htmlContent;
                // THEN position and show the popup
                var atbPosition = clickedButton.offset();
                var containerPosition = $('.product-recs__wrap').offset();
                var popOver = $('.js-select-size-menu');
                var middlePointX = (atbPosition.left - containerPosition.left);
                var atbPositionLeft = middlePointX - 92;

                if (popOver.width() < 234) {
                    atbPositionLeft = middlePointX - 50;
                    var popOverSizes = popOver.children('ul').eq(0);
                    popOverSizes.removeClass('n-block-grid--3');
                    popOverSizes.addClass('n-block-grid--2');
                }

                popOver.css({ 'left': atbPositionLeft, 'display': 'block' });
                $('.popover__header').focus();
                Keyboard.trapFocus(popOver);
                $('.js-modal').modal();
                $('.js-size-select-btn').click(function(e) {
                    $('.js-size-menu-error').addClass('u-hide');
                    var code = $(this).data('code');
                    var sizeElement = $('input[name="size-selection-op-'+ code +'"]:checked');
                    var sizeCode = sizeElement.data('sizeCode');
                    var size = sizeElement.data('size');
                    if (sizeCode && size) {
                        addBeautyAddOns(sizeCode, size, false);
                        target.innerHTML = '';
                    } else {
                        $('.js-size-menu-error').removeClass('u-hide');
                    }
                });

                $('.js-size-select').on('click', function(){
                    $('.js-size-menu-error').addClass('u-hide');
                });
            },
            error: function (xhr, status, error) {
                console.error('Failed to load HTML:', error);
            }
        });

        // Stop propagation to prevent immediate closing
        event.stopPropagation();
    });

    // Document click handler to close popover when clicking outside
    $(document).on('click', function (event) {
        var popOver = $('.js-select-size-menu');
        if (!$(event.target).closest('.js-select-size-menu, .js-sb-add-to-bag-size').length) {
            Keyboard.releaseFocus(popOver, $(popOver.data('lastFocus')));
            popOver.css('display', 'none');
        }
    });

    // Escape key handler to close popover
    $(document).on('keydown', function (event) {
        var popOver = $('.js-select-size-menu');
        if (event.which === 27 || event.keyCode === 27) {
            Keyboard.releaseFocus(popOver, $(popOver.data('lastFocus')));
            popOver.css('display', 'none');
        }
    });
}

$(function() {
    $('.js-lazy-image').lazy({
        effect: 'fadeIn'
    });

    renderCartSocialProof($('.js-cart-item').toArray().map((el) => $(el).data('code')));
    $('.js-cart-item').each((i, el) => {
        initTracking($(el));
    });
    initSizeSelector();
});

window.reApplyCouponForCartRefresh = reApplyCouponForCartRefresh;
window.removeCoupon = removeCoupon;
window.applyCouponCode = applyCouponCode;
window.initTracking = initTracking;



// WEBPACK FOOTER //
// ./src/scripts/entry-points/shoppingbag/index.js